import React from "react";
import ContentPage, { Block, BulletList, CardGrid } from "../components/ContentPage";

const WHY = [
  {
    title: "Speciaal voor Suriname",
    body: "Suriwebwinkel is ontwikkeld voor bestellingen vanuit het buitenland met lokale levering in Suriname.",
  },
  {
    title: "Bestellen vanuit Europa",
    body: "Plaats je bestelling vanaf je telefoon, tablet of computer, waar je ook in Europa woont.",
  },
  {
    title: "Lokale verwerking",
    body: "De bestelling wordt in Suriname verzameld, gecontroleerd en voorbereid.",
  },
  {
    title: "Betrouwbare bezorging",
    body: "Je ontvangt updates over de verwerking en bezorging van je bestelling.",
  },
  {
    title: "Veilig online betalen",
    body: "Betaal via de beschikbare betaalmethoden voor jouw land.",
  },
  {
    title: "Persoonlijke klantenservice",
    body: "Ons team staat voor je klaar via WhatsApp, e-mail of het contactformulier.",
  },
  {
    title: "Producten die echt nodig zijn",
    body: "In plaats van alleen geld te sturen, weet je precies welke producten de ontvanger krijgt.",
  },
];

export default function WaaromPage() {
  return (
    <ContentPage
      title="Waarom kiezen voor Suriwebwinkel?"
      lead="Voor familie en vrienden zorgen kent geen afstand."
      ctaLabel="Start met bestellen"
      secondaryLabel="Hoe het werkt"
      secondaryTo="/hoe-het-werkt"
    >
      <CardGrid items={WHY} />

      <Block title="Meer controle dan geld overmaken">
        <p>
          Geld sturen kan handig zijn, maar je weet niet altijd waarvoor het
          uiteindelijk wordt gebruikt. Met Suriwebwinkel kies je zelf de
          producten die je wilt geven.
        </p>
        <p>Je ziet:</p>
        <BulletList
          items={[
            "Welke producten worden besteld",
            "Wat ieder product kost",
            "Voor wie de bestelling is",
            "Waar de bestelling wordt bezorgd",
            "Wat de totale kosten zijn",
            "Wanneer de bestelling is verwerkt",
          ]}
        />
        <p>Zo weet je precies welke ondersteuning je geeft.</p>
      </Block>

      <Block title="Voor Surinamers en iedereen met een band met Suriname">
        <p>
          Suriwebwinkel is niet alleen voor mensen met een Surinaamse
          achtergrond. Iedereen in Europa kan via ons iets bestellen voor een
          persoon in Suriname — of het nu familie, vrienden, collega&apos;s of
          kennissen zijn.
        </p>
      </Block>
    </ContentPage>
  );
}
